export default __webpack_public_path__ + "static/media/token-header.69a9953d.png";